<template lang="pug" src='./hero-mobile.pug'></template>

<script>
import Icon from 'components/icon/icon'
import { showModal } from '@/mixins'

export default {
  props: ['props'],
  components: {
    Icon
  },
  mixins: [ showModal ],
  methods: {
    moveToPayments () {
      this.$scrollTo('#payments-mobile')
    },
    onScroll ({going, direction}) {
      if (going === 'out') {
        this.$store.dispatch('SCROLL', true)
      }
      if (going === 'in') {
        this.$store.dispatch('SCROLL', false)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero-mobile.vue?8bbf74f2